import {React} from 'common'
import {Images, Styles} from 'appearance'
// import {useIsRtl} from 'store/Store'
import useSideMenu from 'logic/Menu/useSideMenu'
import SideMenuItem from 'components/Page/SideMenu/SideMenuItem'
import {SideMenuDrawer} from './SideMenu/SideMenuDrawer'
import AddClientButton from './Header/AddClientButton'
import List from '@mui/material/List'
import {Box, styled, Toolbar} from '@mui/material'
import {useDeviceDetect} from 'services/hooks'

const SideMenu = ({toggleDrawer, open}) => {
    // const isRtl = useIsRtl()
    const {isMobile} = useDeviceDetect()
    const {topSectionItems, bottomSectionItems} = useSideMenu()

    const {HEADER_HEIGHT, SIDE_MENU_PADDING, DRAWER_WIDTH} = Styles

    return (
        <SideMenuDrawer
            dir="rtl"
            variant={isMobile ? 'temporary' : 'permanent'}
            onClose={toggleDrawer}
            open={open}
            // anchor={isRtl && !isMobile ? 'right' : 'right'}
            anchor={'right'}
            PaperProps={{
                style: {
                    paddingTop: HEADER_HEIGHT + SIDE_MENU_PADDING,
                    width: DRAWER_WIDTH,
                },
            }}>
            <Toolbar style={{justifyContent: 'center'}}>
                <AddClientButton width={150} />
            </Toolbar>
            <SideMenuContainer sx={{overflow: 'auto'}}>
                <List>
                    {topSectionItems.map((item, i) => (
                        <SideMenuItem
                            key={`upper_side_menu_${i}]`}
                            item={item}
                        />
                    ))}
                </List>
                <div>
                    <List>
                        {bottomSectionItems.map((item, i) => (
                            <SideMenuItem
                                key={`lower_side_menu_${i}]`}
                                item={item}
                            />
                        ))}
                    </List>

                    <Logo src={Images.POWERED_BY} />
                </div>
            </SideMenuContainer>
        </SideMenuDrawer>
    )
}

export default SideMenu

const SideMenuContainer = styled(Box)`
    display: flex;
    flex-direction: column;
    height: 100%;
    justify-content: space-between;
`

const Logo = styled('img')`
    height: 25px;
    align-self: center;
    padding-inline: 20px;
    margin-top: 28px;
    margin-bottom: 18px;
`
